// Mirrors Services/MasterChangeLog/Enum/ChangeOrigin.php. Endpoints shared between features (the family
// relationship picker) can't tell which feature called them, so the caller says. A missing or misspelled one
// isn't an error, it just lands in the change log as Unknown.
// The giving and prayer request values are sent ahead of the backend, which drops a value it doesn't know yet (tryFrom).
export const CHANGE_ORIGIN = {
  PROFILE: "profile",
  SIGNUP: "signup",
  REGISTRATION: "registration",
  MERGE: "merge",
  PAYMENT: "payment",
  PLEDGE: "pledge",
  MANAGE_MY_GIVING: "manage_my_giving",
  PRAYER_REQUEST: "prayer_request",
};
